import { CardBody } from './styled'

const Component = props => {
  return (
    <CardBody>
      {props.children}
    </CardBody>
  )
}

export default Component